import { render, staticRenderFns } from "./TheCopyright.vue?vue&type=template&id=570b4ada&scoped=true&"
import script from "./TheCopyright.vue?vue&type=script&lang=js&"
export * from "./TheCopyright.vue?vue&type=script&lang=js&"
import style0 from "./TheCopyright.vue?vue&type=style&index=0&id=570b4ada&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b4ada",
  null
  
)

export default component.exports